import { render, staticRenderFns } from "./ShopCatalogSettings.vue?vue&type=template&id=564e74f7"
import script from "./ShopCatalogSettings.vue?vue&type=script&lang=js"
export * from "./ShopCatalogSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports